import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax

// Override Vuesax notifications for consistency
import VuesaxOverride from './plugins/vuesax-override'

Vue.use(Vuesax)
Vue.use(VuesaxOverride)

// axios
import axios, { setVueInstance } from './axios.js'
Vue.prototype.$http = axios

// API Calls
import './http/requests'

// mock
import './fake-db/index.js'

// Theme Configurations
import '../themeConfig.js'

// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'

// Vuexy Admin Filters
import './filters/filters'

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Tour
// import VueTour from 'vue-tour'
// Vue.use(VueTour)
// require('vue-tour/dist/vue-tour.css')

// VeeValidate
import VeeValidate, { Validator }  from 'vee-validate'
Vue.use(VeeValidate, {
  events: 'input|blur',
})
Validator.extend('phone', {
  getMessage: field => `${field} must be a valid phone number.`,
  validate: value => {
     //const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i;
    const phoneRegex = /^(?:\+?\d{7,20}|\+?\(?\d{3}\)?[-\s.]?\d{3}[-\s.]?\d{4,6})$/; // Matches international formats, with or without parentheses, dashes, or space
    return phoneRegex.test(value)
  }
})
// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAItY1lDXtQqCmgiswgB_u9nOSdQZBUAvg',
    libraries: 'places',
  },
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Singapore')
Vue.use(VueMoment, {
  moment,
})

import VueNumerals from 'vue-numerals'
Vue.use(VueNumerals) // default locale is 'en'

import Croppa from 'vue-croppa'
Vue.use(Croppa)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

import { VueCsvImportPlugin } from 'vue-csv-import'
Vue.use(VueCsvImportPlugin)

import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

import vuetify from '@/plugins/vuetify'
// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

import idleTimer from './plugins/idleTimer';
Vue.use(idleTimer)

// Import notification service
import NotificationService from './services/notification.service'

const app = new Vue({
  router,
  store,
  i18n,
  acl,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')

// Set Vue instance for axios interceptors
setVueInstance(app)

// Initialize notification service
NotificationService.init(app)

// Make notification service globally available
Vue.prototype.$notify = NotificationService
